import _JSXStyle from "styled-jsx/style";
import React, { useMemo } from 'react';
import useTheme from '../use-theme';
import GridBasicItem from './basic-item';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultProps = {
  gap: 0,
  wrap: 'wrap',
  className: ''
};

const GridContainer = ({
  gap,
  wrap,
  children,
  className,
  ...props
}) => {
  const theme = useTheme();
  const gapUnit = useMemo(() => {
    return `calc(${gap} * ${theme.layout.gapQuarter})`;
  }, [gap, theme.layout.gapQuarter]);
  const {
    className: resolveClassName,
    styles
  } = {
    styles: /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2780717249",
      dynamic: [gapUnit, wrap],
      children: `.__jsx-style-dynamic-selector{--grid-gap-unit:${gapUnit};display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:${wrap};-ms-flex-wrap:${wrap};flex-wrap:${wrap};box-sizing:border-box;margin:calc(-1 * var(--grid-gap-unit));width:calc(100% + var(--grid-gap-unit) * 2);}`
    }),
    className: _JSXStyle.dynamic([["2780717249", [gapUnit, wrap]]])
  };
  return /*#__PURE__*/_jsxs(GridBasicItem, {
    className: `${resolveClassName} ${className}`,
    ...props,
    children: [children, styles]
  });
};

GridContainer.defaultProps = defaultProps;
export default /*#__PURE__*/React.memo(GridContainer);